<template>
  <div class="settings-hubspot">
    <h4>Establish Intuit API Connection:</h4>
    <b-row
      v-for="entity in hubspotEntities"
      :key="entity.id"
      no-gutters
    >
      <b-col cols="4">
        {{ entity.name }}
      </b-col>
      <b-col cols="8">
        <b-button>Sync</b-button>
        <b-button>Import</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script lang="ts">
export default {
  metaInfo: {
    title: 'Hubspot Settings'
  },
  data: function () {
    return {
      hubspotEntities: [
        { id: 'contacts', name: 'Contacts' },
        { ide: 'deals', name: 'Deals' }
      ]
    }
  }
}
</script>
